import { axios } from '@/plugins/axios';

const base = '/loyalty';

export function confirmLogin(payload, cfg = {}) {
    return axios.post(`${base}/confirm-login`, payload, {
        ...cfg
    });
}

export function sendLogin(payload, cfg = {}) {
    return axios.post(`${base}/send-login`, payload, {
        ...cfg
    });
}
